// extracted by mini-css-extract-plugin
export default {"melodyVideo":"WJ-z","isFullWidth":"XJ-z","landingPageVideo":"YJ-z","play":"ZJ-z","iframeVideo":"_J-z","playHidden":"aK-z","fullwidth":"bK-z"};